export default [
  {
    path: '/app/admin/map',
    name: 'mapMarkerAdmin',
    components: {
      default: () => import('../../views/mapDevice/indexAdmin.vue')
    }
  },
  {
    path: '/app/admin/map/multipleView',
    name: 'multipleViewAdmin',
    components: {
      default: () => import('../../views/viewMulti/indexAdmin.vue')
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/mapAdmin.js